<template>
<main-content>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#gateway-info" role="tab" aria-selected="false">
                            {{ $t('label.gateway-info') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#shaparak-info" role="tab" aria-selected="false">
                            {{ $t('label.shaparak-info') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#collective-settings" role="tab" aria-selected="false">
                            {{ $t('label.collective_settings') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div class="tab-pane active" id="gateway-info">
                    <kt-row>
                        <kt-col xs="12" md="6">
                            <gateway-info :form_data="form_data" :submit="submit"  v-if="status == 'setFormData'"></gateway-info>
                        </kt-col>
                        <kt-col xs="12" md="6">
                            <gateway-statistics></gateway-statistics>
                            <gateway-setting></gateway-setting>
                        </kt-col>
                    </kt-row>
                </div>
                <div class="tab-pane" id="shaparak-info">
                    <shaparak-info
                            :form_data="form_data"
                            :addresses="addresses"
                            :sheba_numbers="sheba_numbers"
                    ></shaparak-info>
                </div>
                <div class="tab-pane" id="collective-settings">
                    <collective-setting :shop_type="0"></collective-setting>
                    <switching-setting-user :gateway_hashid="hashid"></switching-setting-user>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { gatewayService } from '@/common/api.service'
import { gatewaySetting, gatewayInfo, shaparakInfo } from './components'
import gatewayStatistics from './components/gateway-statistics'
import $ from 'jquery'
import collectiveSetting from '../collective/components/collective-settings'
import switchingSettingUser from './components/SwitchingSettingUser'

export default {
    components: {
        mainContent,
        gatewaySetting,
        gatewayInfo,
        shaparakInfo,
        collectiveSetting,
        switchingSettingUser,
        'gateway-statistics': gatewayStatistics
    },
    computed: {
        ...mapGetters('gateway', [
            'form_data', 'status'
        ]),
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'sheba_numbers'
        ])
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
            active_pane: '#gateway-info'
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
                vm.$store.dispatch('gateway/find', vm.hashid)
        })
    },
    methods: {
        submit(e) {
            let form = $('#gateway_form')
            let btn = $('#submit_btn')

            KTApp.progress(btn)

            let params = this.$store.getters['gateway/form_data']
            // let form_data = new FormData
            gatewayService.update(this.hashid, params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            })
                .catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                })
        },
    },
    mounted() {
        this.$store.dispatch('shebaNumber/fetchByShopId', {
            'hashid': this.hashid,
            'shop_type': 0
        })
            .finally(() => {
                Object.keys(this.sheba_numbers).map(key => {
                    let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
                    this.sheba_numbers[key]['number'] = number
                })
            })
        this.$store.dispatch('address/fetchByShopId', {
            'hashid': this.hashid,
            'shop_type': 0
        })
    }
}
</script>

<style>
@media (min-width: 768px) {
    #gateway-info > div > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>